/* eslint-disable react/prop-types */
import { ApiClient } from '@api/api-configuration';
import { captureError } from '@app/lib/Sentry';
import {
  ExternalProviderChoice,
  ExternalProviderSelect,
} from '@app/components/ui/ExternalProviderSelect/ExternalProviderSelect';
import { useEffect, useState } from 'react';
import { CustomComponentInputs } from '../filters.types';

// Single-provider filter, inactive providers included so their past visits stay filterable; loads the named provider so a value from the URL shows its name.
export const ExternalProviderFilterSelect: React.FC<CustomComponentInputs> = ({ onChange, value }) => {
  const [loaded, setLoaded] = useState<ExternalProviderChoice | null>(null);
  const id = Array.isArray(value) ? Number(value[0]) : value ? Number(value) : undefined;

  useEffect(() => {
    if (!id) {
      setLoaded(null);
      return;
    }
    ApiClient.caregiverApi.externalProviders
      .getExternalProvider(id)
      .then((res) => setLoaded(res.data as ExternalProviderChoice))
      .catch((error) => {
        captureError(error instanceof Error ? error : new Error('Error fetching external provider'), {
          externalProviderId: id,
          component: 'ExternalProviderFilterSelect',
        });
      });
  }, [id]);

  return (
    <ExternalProviderSelect
      allowClear
      includeInactive
      value={id}
      selectedProvider={loaded}
      onProviderChange={(provider) => onChange(provider ? provider.externalProviderId : null)}
      style={{ width: '100%', height: '44px' }}
    />
  );
};
